import "../bootstrap.min.css";
import "../style.css";
import "../responsive.css";
import "../custom.css";
import { useGetTranslation } from "../../Components/Translate";

export default function Message({ messageRef, defaultMessage = "" }) {
  const getTranslation = useGetTranslation();

  return (
    <div className="row mt-4 g-2">
      <div className="col-12">
        <textarea
          id="message"
          name="message"
          ref={messageRef}
          defaultValue={defaultMessage}
          className="form-control message"
          rows={5}
          maxLength={400}
          placeholder={getTranslation(
            "STEP3_PLACEHOLDER_MESSAGE_TO_SELLER",
            "Message to the seller"
          )}
          style={{
            // keep only what you truly need:
            fontSize: "13px",
            // remove custom width/margins; let the grid control alignment
          }}
        />
      </div>
    </div>
  );
}
